var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChairsideLeftScreenshots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Search Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Channels",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chairside-education,-Home",
    transform: "translate(-31.000000, -504.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search-Copy-3",
    transform: "translate(31.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.553846154,0 C0.246153846,0.0297297297 0,0.297297297 0,0.594594595 L0,21.4054054 C0,21.7027027 0.307692308,22 0.615384615,22 L23.3846154,22 C23.6923077,22 24,21.7027027 24,21.4054054 L24,0.594594595 C24,0.267567568 23.6923077,0 23.3846154,0 C23.3846154,0 0.553846154,0 0.553846154,0 Z M1,1 L23,1 L23,16 L1,16 L1,1 Z M14.2934007,3 C14.525835,3 14.7292151,3.08894879 14.8163779,3.29649596 L14.8163779,3.29649596 L20.917779,13.0808625 C21.1502133,13.4366577 20.8596704,14 20.423856,14 L20.423856,14 L3.5723674,14 C3.16560733,14 2.84601013,13.4366577 3.07844446,13.0808625 L3.07844446,13.0808625 L7.72713098,5.37196765 C7.84334815,5.19407008 8.01767389,5.0754717 8.19199964,5.0754717 C8.39537967,5.0754717 8.59875971,5.16442049 8.71497687,5.31266846 L8.71497687,5.31266846 L10.8068858,8.15902965 L13.8575863,3.26684636 C13.9447492,3.11859838 14.119075,3 14.2934007,3 Z M19.5,3 C20.3284271,3 21,3.67157288 21,4.5 C21,5.32842712 20.3284271,6 19.5,6 C18.6715729,6 18,5.32842712 18,4.5 C18,3.67157288 18.6715729,3 19.5,3 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairsideLeftScreenshots);
export default __webpack_public_path__ + "static/media/Chairside-Left-Screenshots.000f8e12.svg";
export { ForwardRef as ReactComponent };